<div class="container">
    <div class="row d-flex justify-content-center">
        <div class="col-md-12 text-center">
            <h1>Backtest completo</h1>
        </div>
    </div>
    <div class="row justify-content-end">
        <div class="col-2 d-flex">
            <input mdbCheckbox type="checkbox" name="onlypos" id="onlypos" class="form-check-input"/><span>Solo positive</span>
        </div>
        <div class="col-2 d-flex flex-row-reverse">
            <button type="button" class="btn btn-primary" mdbButton (click)="calcolaBT()">Esegui BT</button>
        </div>
    </div>
    <div class="row d-flex justify-content-center">
        <table class="table">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Market</th>
                    <th>Day Week</th>
                    <th>Verso</th>
                    <th>Swing</th>
                    <th>Num Op</th>
                    <th>Profit</th>
                    <th>% Pos.</th>
                    <th>Punti/Op (pip)</th>
                    <th>Rawal</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let r of dati; let i = index">
                    <td>{{i+1}}</td>
                    <td>{{r.market}}</td>
                    <td>{{r.dayweek}}</td>
                    <td>{{r.verso}}</td>
                    <td>{{r.swing}}</td>
                    <td>{{r.num}}</td>
                    <td>{{r.profit | number : '1.4-4'}}</td>
                    <td>{{r.percpos | number :'1.2-2'}}%</td>
                    <td>{{r.profitpip | number : '1.2-2'}}</td>
                    <td>{{r.rawal | number : '1.4-4'}}</td>
                </tr>
            </tbody>
        </table>

    </div>
</div>